module.exports = __webpack_public_path__ + "assets/img/role-62c85217.png";